import { useIntl } from 'react-intl';
import Circle from '@uiw/react-color-circle';
import { ColorResult } from '@uiw/color-convert';
import { Form, FormInstance, Input } from 'antd';

import { FloatingFormItem } from '@/components/_common';
import {
  useDefaultEmptyFieldError,
  useDefaultMaxLengthFieldError,
} from '@/hooks';

export interface CompanyWorkorderItemTagFormData {
  description: string;
  color: string;
}

interface CompanyWorkorderItemTagFormProps {
  form: FormInstance<CompanyWorkorderItemTagFormData>;
}

function CompanyWorkorderItemTagForm({
  form,
}: CompanyWorkorderItemTagFormProps) {
  const intl = useIntl();
  const defaultEmptyError = useDefaultEmptyFieldError();
  const defaultMaxLenghtFieldError = useDefaultMaxLengthFieldError();

  return (
    <Form form={form} preserve={false}>
      <FloatingFormItem
        name="description"
        label={intl.formatMessage({
          id: 'companies.settings.itemTags.entity.description',
        })}
        rules={[defaultEmptyError, defaultMaxLenghtFieldError(15)]}
      >
        <Input />
      </FloatingFormItem>

      <Form.Item
        name="color"
        label={intl.formatMessage({
          id: 'companies.settings.itemTags.entity.color',
        })}
        style={{ marginTop: '24px' }}
        getValueFromEvent={(e: ColorResult) => {
          return e.hex;
        }}
        rules={[defaultEmptyError]}
        valuePropName="color"
      >
        <Circle
          colors={[
            '#F44336',
            '#E91E63',
            '#9C27B0',
            '#673AB7',
            '#3F51B5',
            '#2196F3',
            '#03A9F4',
            '#00BCD4',
            '#009688',
            '#4CAF50',
            '#8BC34A',
            '#CDDC39',
            '#FFEB3B',
            '#FFC107',
            '#FF9800',
            '#FF5722',
            '#795548',
            '#607D8B',
          ]}
        />
      </Form.Item>
    </Form>
  );
}

export default CompanyWorkorderItemTagForm;
